import './ParticipantResponsibleModal.scss'

const ParticipantResponsibleModal = ({ responsible }) => {
  return (
    <div className='responsible-modal-container'>
      {responsible ? (
        <>
          <div className='responsible-field'>
            <span>Nome:</span>
            <p>{responsible.name ? responsible.name : 'Não informado'}</p>
          </div>
          <div className='responsible-field'>
            <span>Parentesco:</span>
            <p>
              {responsible.relationshipType
                ? responsible.relationshipType
                : 'Não informado'}
            </p>
          </div>
          <div className='responsible-field'>
            <span>Telefone:</span>
            <p>{responsible.phone ? responsible.phone : 'Não informado'}</p>
          </div>
          <div className='responsible-field'>
            <span>Email:</span>
            <p>{responsible.email ? responsible.email : 'Não informado'}</p>
          </div>
        </>
      ) : (
        <h5>Nenhum responsável cadastrado</h5>
      )}
    </div>
  )
}

export default ParticipantResponsibleModal
